import BootstrapField from '../utility/BootstrapField';

// import CloneDeep from 'lodash.clonedeep';
import LaneClosureRequestBlock from '../models/LaneClosureRequestBlock';
import LaneClosureRequestPresetBlock from '../models/LaneClosureRequestPresetBlock';
import LaneClosureRequestMessage from '../models/LaneClosureRequestMessage';
import Contravention from '../models/Contravention';
import Attachment from '../models/Attachment';

export default class LaneClosureRequestListEntry {
	constructor(data) {
		let x = 0;
		if (!data) {
			data = {}
		}
		Object.assign(this, {
			id: data.id || null,
			ownerId: data.ownerId || null,
			requesterId: data.requesterId || null,
			requesterProjectId: data.requesterProjectId || null,
			ownerProjectId: data.ownerProjectId || null,
			createdDate: data.createdDate || null,
			modifiedDate: data.modifiedDate || null,
			projectBidNumber: data.projectBidNumber || null,
			projectTwo: data.projectTwo || null,
			affectedStreet: data.affectedStreet || null,
			firstCrossStreet: data.firstCrossStreet || null,
			lastCrossStreet: data.lastCrossStreet || null,
			isUnderTwoHours: typeof data.isUnderTwoHours === 'number' ? data.isUnderTwoHours : null,
			fromDate: data.fromDate || null,
			toDate: data.toDate || null,
			fromTime: data.fromTime || null,
			toTime: data.toTime || null,
			recordStatusId: typeof data.recordStatusId === 'number' ? data.recordStatusId : null,
			approvalStatusId: typeof data.approvalStatusId === 'number' ? data.approvalStatusId : null,
			completeTypeId: typeof data.completeTypeId === 'number' ? data.completeTypeId : null,
			isEmergency: typeof data.isEmergency === 'number' ? data.isEmergency : null,
			requesterComments: data.requesterComments || null,
			trafficManagementRef: data.trafficManagementRef || null,
			directionId: data.directionId || null,
			natureOfWorkId: data.natureOfWorkId || null,
			closureOwnerId: data.closureOwnerId || null,
			closureReporterId: data.closureReporterId || null,
			restrictionOwnerId: data.restrictionOwnerId || null,
			restrictionReporterId: data.restrictionReporterId || null,
			ownerProjectName: data.ownerProjectName || null,
			requesterProjectName: data.requesterProjectName || null,
			owner: data.owner || null,
			requester: data.requester || null,
			closureOwner: data.closureOwner || null,
			closureReporter: data.closureReporter || null,
			restrictionOwner: data.restrictionOwner || null,
			restrictionReporter: data.restrictionReporter || null,

			// multiple-value attributes
			altRequester: data.altRequester || [],
			altClosureReporter: data.altClosureReporter || [],
			altRestrictionReporter: data.altRestrictionReporter || [],
			attachment: [],
			block: [],
			presetBlock: [],
			message: [],
			contravention: [],
			contact: data.contact || [],
			email: data.email || [],
			geometry: data.geometry || [],
			closureActiveStatusId: typeof data.closureActiveStatusId === 'number' ? data.closureActiveStatusId : null,
			restrictionActiveStatusId: typeof data.restrictionActiveStatusId === 'number' ? data.restrictionActiveStatusId : null,
			warningMessage: data.warningMessage || null,
			conflicts: data.conflicts || null,
			isDirtyFlag: false,
		});
		if (data.block instanceof Array) {
			for (x = 0; x < data.block.length; x++) {
				this.block.push(new LaneClosureRequestBlock(data.block[x]));
			}
		}
		// presets are very similar
		if (data.presetBlock instanceof Array) {
			for (x = 0; x < data.presetBlock.length; x++) {
				this.presetBlock.push(new LaneClosureRequestPresetBlock(data.presetBlock[x]));
			}
		} else {
			// put in a default preset...
			this.presetBlock.push(new LaneClosureRequestPresetBlock());
		}
		// set the expanded traffic signal altered flag.
		this.presetBlock[0].expandTrafficSignalsAltered = false;

		if (data.message instanceof Array) {
			for (x = 0; x < data.message.length; x++) {
				this.message.push(new LaneClosureRequestMessage(data.message[x]));
			}
		}

		if (data.attachment instanceof Array) {
			for (x = 0; x < data.attachment.length; x++) {
				this.attachment.push(new Attachment(data.attachment[x]));
			}
		}
		if (data.contravention instanceof Array) {
			for (x = 0; x < data.contravention.length; x++) {
				this.contravention.push(new Contravention(data.contravention[x]));
			}
		}
	}

	getRawValue() {
		return getRawValue(this);

		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							if (typeof obj[key][arrKey] != "function") {
								value[key].push(getRawValue(obj[key][arrKey]));
							}
						}
					} else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								if (obj instanceof LaneClosureRequestBlock && key == "sRoute") {
									// we won't be submitting sRoute...
								} else {
									value[key] = getRawValue(obj[key]);
								}
							}
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);

		function getValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					} else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								value[key] = getValue(obj[key]);
							}
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}
}